import dayjs from 'dayjs';
import consts from '../consts';
import Model from '../models/model';
import util from '../util';

const { renderAttachmentButton } = util;
const model = new Model({
	name: 'Cycle',
	disableAdd: true,
	disableDelete: true,
	disableExport: false,
	defaultSort: 'CycleStart DESC',
	title: "Reliance Cycle",
	showGridRefreshBtn: true,
	headerFilterProps: {
		className: 'HeaderFilterForm'
	},
	columns: [
		{ field: 'CycleName', header: "EventName", width: 200 },
		{ field: 'CycleStart', header: "CycleDateTime", width: 200, type: 'dateTime' },
		{ field: 'ErrorDescription', header: "AlarmDescription", width: 200 },
		{ field: 'Label', header: "Label", width: 150 },
		{ field: 'InstrumentName', header: "Endoscope", width: 150 },
		{ field: 'InstrumentSN', header: "EndoscopeId", width: 150 },
		{ field: 'ModelNumber', header: "EndoscopeType", width: 150 },
		{ field: 'OperatorName', header: "OperatorName", width: 150 },
		{ field: 'OperatorID', header: "OperatorID", width: 150 },
		{ field: 'AttachFile', header: "AttachFile", width: 150, renderCell: ({ row }) => (renderAttachmentButton(row)), filterable: false, isNotExportField: true },
		{
			field: 'startDate',
			header: 'Start Date',
			width: 100,
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			isNotformfield: true,
			filterable: false,
			maxDate: ({ formik }) => (formik.values.endDate ? dayjs(formik.values.endDate) : undefined),
			hidden: true
		},
		{
			field: 'endDate',
			header: 'End Date',
			width: 100,
			headerFilter: true,
			standaloneHeaderFilter: true,
			type: 'date',
			format: consts.MomentFormat.MonthDateYear,
			isNotformfield: true,
			minDate: ({ formik }) => (formik.values.startDate ? dayjs(formik.values.startDate) : undefined),
			hidden: true
		}
	]
});
export const RelianceTable = model;
export default model.createFormBase();
